module.exports = __webpack_public_path__ + "static/media/utransfer-logo-pdf.2e9911df.png";